"use client";
import styles from "@/src/app/phong-kham/[slug]/page.module.scss";
import { STROKE_COLOR, TRAIL_COLOR } from "@/src/const/const";
import { Col, Row } from "antd";
import StarRatings from "react-star-ratings";

export default function ItemOverviewRatingNew(props) {
  const { nameService, totalRating, key, className } = props;
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  return (
    <Col span={24} className={className} key={key}>
      <Row style={{ "align-items": "baseline" }}>
        <Col span={isMobile ? 14 : 12}>
          <div className={styles.serviceName}>{nameService}</div>
        </Col>
        <Col span={isMobile ? 10 : 12}>
          <StarRatings
            rating={totalRating ? totalRating : 0}
            starRatedColor={STROKE_COLOR}
            starEmptyColor={TRAIL_COLOR}
            starDimension="16px"
            starSpacing={isMobile ? "5px" : "8px"}
            numberOfStars={5}
            name="rating"
            isAggregateRating
          />
        </Col>
      </Row>
    </Col>
  );
}
